import * as React from "react";
import {Link, IRouterContext, Router} from "react-router";
import {DashboardUserProfile} from "../user/DashboardUserProfile";
import {MenuService, MENU_SERVICE_NAME, MenuRoute} from "../../service/MenuService";
import {UserStoreState} from "../../store/UserStore";
import {AppCtx} from "../../ioc/ApplicationContext";
import {GroupPermission} from "../../../generated/protocol";

interface MainMenuProps extends UserStoreState {
    location?: Location;
    routes?: any[];
}

interface Context {
    router?: Router
}

export class MainMenu extends React.Component<MainMenuProps, {}> {

    context: IRouterContext & Context;
    versionStr: string;

    static contextTypes = {
        router: React.PropTypes.object.isRequired
    }

    routes: MenuRoute[];

    constructor(props) {
        super(props);
        this.versionStr = this.getAppVersion();
    }

    isActive(path: string, children?: MenuRoute[]): boolean {

        var active = this.props.routes.some(r => {
            return r.path != null && r.path == path;
        });
        active = active || children != null && children.some(c => {
            return this.isActive(c.path, null)
        });
        return active;

    }

    getSubMenu(path: string): string {
        // return this.location.path().indexOf(path) != -1 ? "" : "collapse";
        return "";
    }

    getAppVersion(): string {
        return (window as any).appversion;
    }

    getChildren(children: MenuRoute[]) {
        if (!children || !children.length) {
            return [];
        }
        return children.map(c => {
            if (c.displayInMenu == false) {
                return false;
            }
            return (
                <li key={c.path}>
                    <Link to={c.path} href="#">{c.label}</Link>
                </li>

            );
        })
    }

    getRoutes() {
        if (this.props.user == null) {
            return [];
        } else {
            return AppCtx.resolve<MenuService>(MENU_SERVICE_NAME).getMenuRoutes(this.props.activeRole, this.props.permissions);
        }
    }

    getMenuItems() {
        var allRoutes = this.getRoutes();
        return allRoutes.map(route => {
            if (route.displayInMenu == false) {
                return false;
            }
            var active = this.isActive(route.path, route.children);

            return (
                <li key={route.path} className={active ? "active" : ""}>
                    <Link to={route.path} href="#">
                        <i className={"fa fa-" + route.icon}></i>
                        <span className="nav-label">{route.label}</span>
                        {route.children ? <span className="fa arrow"></span> : ""}
                    </Link>
                    <ul className={"nav nav-second-level" + (active ? "" : " collapse")}>
                        {this.getChildren(route.children)}
                    </ul>
                </li>
            )
        });
    }

    render() {
        return (
            <nav className="navbar-default navbar-static-side" role="navigation">
                <div className="slimScrollDiv"
                     style={{position: "relative", overflow: "hidden", width: "auto", height: "100%"}}>
                    <div className="sidebar-collapse">
                        <ul className="nav metismenu" id="side-menu">
                            <li className="nav-header">
                                <DashboardUserProfile user={this.props.user}/>
                                <div className="m-r-sm text-muted welcome-message">
                                    <span>
                                        <strong className="font-bold">v&nbsp;{this.versionStr}</strong>
                                    </span>
                                </div>
                                <div className="logo-element">
                                    IN+
                                </div>
                            </li>
                            {this.getMenuItems()}
                        </ul>
                    </div>
                </div>
            </nav>
        );
    }

}



// WEBPACK FOOTER //
// ./src/app/ui/navbar/MainMenu.tsx